import type { UptimeTokenRequest } from '@fleet-bffs/api-contract';
import { bffWebApi } from '~/api';

const uptimeApi = bffWebApi.injectEndpoints({
  endpoints: (build) => ({
    exchangeUptimeToken: build.mutation<UptimeTokenRequest, any>({
      query: (body) => ({
        url: `${process.env.ENDPOINT_BFF}/uptime/token`,
        method: 'POST',
        body: body,
      }),
    }),
    deleteUptimeToken: build.mutation<void, void>({
      query: () => ({
        url: `${process.env.ENDPOINT_BFF}/uptime/token`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const { useExchangeUptimeTokenMutation, useDeleteUptimeTokenMutation } = uptimeApi;
export default uptimeApi;
